export const environment = {
  production: true,
  version: require('../../package.json').version,
  versionCheckURL: 'https://admin.freightseeker.com/assets/version.json',
  Api: Object.freeze({
    url: 'https://api.freightseeker.com/',
    version: 'v1'
  }),
  Payment: Object.freeze({
    url: 'https://live.adyen.com/hpp/cse/js/2614967456720858.shtml',
    cardNumber: '',
    holderName: '',
    expiryDate: '',
    expiryMonth: '',
    expiryYear: '',
    cvc: '',
    card: ''
  }),
  Unifaun: Object.freeze({
    waybillProducts: [46, 47, 48]
  })
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts